import { render, staticRenderFns } from "./MasterChip.vue?vue&type=template&id=4024ce48&scoped=true"
import script from "./MasterChip.vue?vue&type=script&lang=js"
export * from "./MasterChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024ce48",
  null
  
)

export default component.exports